/* eslint-disable sonarjs/no-identical-functions */
import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import ListGroup from '@vfuk/core-list-group'
import ListItem from '@vfuk/core-list-item'
import { spacing } from '@vfuk/core-mixins'

export const LinksWrapper = styled(ListGroup)(
  (): FlattenSimpleInterpolation => css`
    ${spacing('margin-bottom', 6)}
  `,
)

export const RowListGroup = styled(ListGroup)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
  `,
)

export const ListItemWrapper = styled(ListItem)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
  `,
)

export const LinksRow = styled(ListItem)(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    justify-content: center;
    ${spacing('margin-top', 2)}

    &:first-child {
      ${spacing('margin-top', 0)}
    }
  `,
)
